// extracted by mini-css-extract-plugin
export default {"accentTitle":"PlanCardDescription_accentTitle__a9T0s","caption":"PlanCardDescription_caption__8cA4v"};